import { render, staticRenderFns } from "./slaedshow.vue?vue&type=template&id=34d52883&"
import script from "./slaedshow.vue?vue&type=script&lang=js&"
export * from "./slaedshow.vue?vue&type=script&lang=js&"
import style0 from "./slaedshow.vue?vue&type=style&index=0&id=34d52883&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports